import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Todoist = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      id="todoist_layer_2_"
      fill="hsl(from hsl(5 76% 55%) h s 49%)"
      d="M21.9,0L3.1,0C1.4,0,0,1.4,0,3l0,18c0,1.6,1.4,3,3.1,3l18.8,0c1.7,0,3.1-1.4,3.1-3l0-18
	C25,1.3,23.6,0,21.9,0z"
    />
    <path
      id="todoist_layer_1_"
      fill="hsl(from hsl(5 76% 55%) h s 100%)"
      d="M5.3,11.4c0.4-0.2,9.8-5.5,10-5.6c0.2-0.1,0.2-0.5,0-0.6c-0.2-0.1-0.7-0.4-0.9-0.5
	c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0.1-8.1,4.6-8.4,4.7c-0.3,0.2-0.7,0.2-1,0L0,7l0,2c1,0.6,3.6,2,4.2,2.4C4.6,11.6,4.9,11.6,5.3,11.4z"
    />
    <path
      id="todoist_layer"
      fill="hsl(from hsl(5 76% 55%) h s 100%)"
      d="M5.3,15.2c0.4-0.2,9.8-5.5,10-5.6c0.2-0.1,0.2-0.5,0-0.6c-0.2-0.1-0.7-0.4-0.9-0.5
	c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0.1-8.1,4.6-8.4,4.7c-0.3,0.2-0.7,0.2-1,0L0,10.8l0,2c1,0.6,3.6,2,4.2,2.4C4.6,15.4,4.9,15.4,5.3,15.2
	z"
    />
    <path
      id="todoist_layer_3_"
      fill="hsl(from hsl(5 76% 55%) h s 100%)"
      d="M5.3,19.3c0.4-0.2,9.8-5.5,10-5.6c0.2-0.1,0.2-0.5,0-0.6c-0.2-0.1-0.7-0.4-0.9-0.5
	c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0.1-8.1,4.6-8.4,4.7c-0.3,0.2-0.7,0.2-1,0L0,14.9l0,2c1,0.6,3.6,2,4.2,2.4C4.6,19.5,5,19.5,5.3,19.3z"
    />
  </svg>
);
